import React from 'react';
import moment, { Moment } from 'moment-timezone';

import styles from './dateTimeRangeSelector.module.scss';
import { DatePicker } from './datePicker/datePicker';

type DateTimeRangeSelectorOwnProps = {
  onChange: (selected: { startDate: Moment; endDate: Moment }) => void;
  startDate?: string | Moment;
  endDate?: string | Moment;
};

export class DateTimeRangeSelector extends React.Component<DateTimeRangeSelectorOwnProps> {
  getDate = (date: string | Moment) => {
    if (moment.isMoment(date)) {
      return date;
    }

    return moment(date);
  };

  handleDateChange = (key: 'startDate' | 'endDate') => (value: Moment) => {
    const { startDate, endDate, onChange } = this.props;

    onChange({
      startDate: this.getDate(startDate),
      endDate: this.getDate(endDate),
      [key]: value,
    });
  };

  public render() {
    const { startDate, endDate } = this.props;

    const momentStartDate = this.getDate(startDate);
    const momentEndDate = this.getDate(endDate);

    return (
      <>
        <div className={styles.datePickerWrapper}>
          <span className={styles.label}>From:</span>
          <span className={styles.datePicker}>
            <DatePicker
              selected={momentStartDate}
              startDate={momentStartDate}
              endDate={momentEndDate}
              onChange={this.handleDateChange('startDate')}
              selectsStart
            />
          </span>
        </div>
        <div className={styles.datePickerWrapper}>
          <span className={styles.label}>To:</span>
          <span className={styles.datePicker}>
            <DatePicker
              selected={momentEndDate}
              startDate={momentStartDate}
              endDate={momentEndDate}
              onChange={this.handleDateChange('endDate')}
              selectsEnd
            />
          </span>
        </div>
      </>
    );
  }
}
